import React from 'react';
import PropTypes from 'prop-types';
import { FormFeedback, Input } from 'reactstrap';
import get from 'lodash/get';
import classNames from 'classnames';

import Button from 'components/App/Button';

import { ROOM_TYPE } from 'constants/index';
import INITIAL_VALUE from 'constants/initialValue';
import { checkHadError } from 'utils';

import styles from './AppCheckboxList.module.scss';

function AppCheckboxList(props) {
  const {
    isVertical,
    name,
    list,
    validation,
    onChecked,
    onToggleCheckedAll,
  } = props;

  const isDisableCheckAllButton = React.useMemo(() => list.every((item) => item.isChecked), [list]);

  const isDisableUnCheckAllButton = React.useMemo(() => (
    !list.some((item) => item.isChecked)
  ), [list]);

  const getItemIdentifier = (item) => item._id || `${item.roomName || ''}-${item.name || ''}-${item.value || ''}`;

  const getItemDisplayName = (item) => {
    if (item.name) return item.name;
    if (item.roomName && ROOM_TYPE[item.roomName]?.label) return ROOM_TYPE[item.roomName].label;
    return item.label || 'Unnamed';
  };

  return (
    <div className={classNames(styles.Component, isVertical && styles.Vertical)}>
      <div className={styles.DateSelect}>
        <div className={styles.CheckboxContainer}>
          {list.map((item) => {
            const identifier = getItemIdentifier(item);
            return (
              <div className={styles.CheckboxWrap} key={identifier}>
                <Input
                  id={identifier}
                  value={identifier}
                  type="checkbox"
                  checked={item.isChecked}
                  className={styles.Checkbox}
                  onChange={(e) => {
                    onChecked({
                      ...e,
                      target: {
                        ...e.target,
                        value: item.roomName || item.value,
                        originalItem: item,
                      },
                    });
                  }}
                />
                <label className={styles.CheckboxLabel} htmlFor={identifier}>
                  {getItemDisplayName(item)}
                </label>
              </div>
            );
          })}
        </div>

        {checkHadError(validation, name, '') && (
          <FormFeedback type="invalid" className={styles.Feedback}>
            {get(validation.errors, name, '')}
          </FormFeedback>
        )}
      </div>

      <div className={styles.ButtonWrap}>
        <Button
          isDefault
          classes={classNames(styles.Button, styles.ButtonSelectAll)}
          value={1}
          type="button"
          disabled={isDisableCheckAllButton}
          onClick={onToggleCheckedAll}
        >
          Chọn tất cả
        </Button>

        <Button
          isDefault
          classes={classNames(styles.Button, styles.ButtonUnSelectAll)}
          value={2}
          type="button"
          disabled={isDisableUnCheckAllButton}
          onClick={onToggleCheckedAll}
        >
          Xoá tất cả lựa chọn
        </Button>
      </div>
    </div>
  );
}

AppCheckboxList.propTypes = {
  isVertical: PropTypes.bool,
  name: PropTypes.string.isRequired,
  list: PropTypes.instanceOf(Array).isRequired,
  validation: PropTypes.instanceOf(Object),
  onChecked: PropTypes.func.isRequired,
  onToggleCheckedAll: PropTypes.func.isRequired,
};

AppCheckboxList.defaultProps = {
  isVertical: false,
  validation: INITIAL_VALUE.OBJECT,
};

export default React.memo(AppCheckboxList);
